export default __webpack_public_path__ + "static/media/share.b03ec167.svg";